import React from 'react';
import Victory from '@/victory';
import { PEPPER_GREEN } from '@/styles';

const CHART_PADDING = { bottom: 0, left: 10, right: 10, top: 0 };
const MAX_SPEECH_LEVEL = 10;
const VOICE_ACVITITY_THRESHOLD = 2;

interface WaveformChartData {
  x: number;
  y: number;
}

interface Props {
  height: number;
  speechVolumeStream: number[];
  width: number;
}

const generateWaveFormData = (data: number[]) => {
  const waveform: WaveformChartData[] = [];

  // Always start with 0 amplitude
  waveform.push({
    x: 0,
    y: 0,
  });

  for (let i = 0; i < data.length; i++) {
    const value = data[i];
    const xBase = waveform.length;
    // Add corresponding positive and negative amplitude along with center 0 node
    waveform.push(
      ...[
        {
          x: xBase,
          y: value > VOICE_ACVITITY_THRESHOLD ? value : 0,
        },
        {
          x: xBase + 1,
          y: 0,
        },
        {
          x: xBase + 2,
          y: value > VOICE_ACVITITY_THRESHOLD ? -value : 0,
        },
      ],
    );
  }

  // Always end with 0 amplitude
  waveform.push({
    x: waveform.length,
    y: 0,
  });

  return waveform;
};

export const SpeechWaveform: React.FC<Props> = ({
  height,
  speechVolumeStream,
  width,
}) => {
  const waveformData = generateWaveFormData(speechVolumeStream);

  return (
    <Victory.VictoryChart height={height} padding={CHART_PADDING} width={width}>
      <Victory.VictoryAxis
        dependentAxis
        domain={{ y: [-MAX_SPEECH_LEVEL, MAX_SPEECH_LEVEL] }}
        style={{
          axis: { stroke: 'none' },
          tickLabels: { fill: 'none' },
          ticks: { stroke: 'none' },
        }}
      />
      <Victory.VictoryLine
        data={waveformData}
        interpolation="natural"
        style={{
          data: { fill: 'none', stroke: PEPPER_GREEN, strokeWidth: 1 },
        }}
      />
    </Victory.VictoryChart>
  );
};
